module.exports = __webpack_public_path__ + "static/media/week-measurements-50.2a2642e2.svg";